import { collection, doc, writeBatch } from 'firebase/firestore';
import { db } from '../firebase';

const FIRESTORE_BATCH_MAX = 400;

/** Supprime des documents par id (lots de 400 max par commit Firestore). */
export async function deleteDocsInCollection(
  collectionName: string,
  ids: string[]
): Promise<void> {
  const unique: string[] = [];
  const seen = new Set<string>();
  for (const raw of ids) {
    const id = String(raw).trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    unique.push(id);
  }
  if (!unique.length) return;

  for (let i = 0; i < unique.length; i += FIRESTORE_BATCH_MAX) {
    const slice = unique.slice(i, i + FIRESTORE_BATCH_MAX);
    const batch = writeBatch(db);
    slice.forEach((id) => {
      batch.delete(doc(collection(db, collectionName), id));
    });
    await batch.commit();
  }
}
